import state from './moduleHomepageManagementState.js'
import mutations from './moduleHomepageManagementMutations.js'
import actions from './moduleHomepageManagementActions.js'
import getters from './moduleHomepageManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters

}

